import { isDev } from '@/constants/env'
import { type Config, config } from '@ruguoapp/jk-analytics'

let configs: Config = {
	project: 'jike',
	debug: isDev,
	serverUrl: 'https://tr.ruguoapp.com/sa.gif',
	rawObject: true,
}

export function configTracker(newConfigs: Partial<Config>) {
	configs = {
		...configs,
		...newConfigs,
	}

	config(configs)
}

export function initTracker() {
	config(configs)
}
